<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading" tip="正在提交数据....">
            <audio preload="load" id="voice">
                <source src="../../../assets/audio/roam.mp3" type="audio/mp3"/>
            </audio>
            <a-form class="ant-advanced-search-form">
                <a-row class="searchrow width-style-auto">
                    <a-form-item :colon="false" label="就诊机构">
                        <a-select v-model="search.hospitalId">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.organs" :key="item.oid" :value="item.oid">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item v-if="false" :colon="false" label="业务状态">
                        <a-select v-model="search.status">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                                {{item.value}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :colon="false" label="处方单号">
                        <a-input v-model="search.code" placeholder="请输入处方单号检索">
                            <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png"
                                 @click="searchAction"/>
                        </a-input>
                    </a-form-item>
                </a-row>
            </a-form>
            <a-row class="search"></a-row>

            <a-tabs type="card" class="custom-table-tabs" @change="tabChange">
                <a-tab-pane key="ALL" tab="全部">
                </a-tab-pane>
                <a-tab-pane key="B_WAIT_ACCEPT" tab="待受理">
                </a-tab-pane>
                <a-tab-pane key="C_ACCEPTED" tab="待发货">
                </a-tab-pane>
                <a-tab-pane key="D_DELIVERED" tab="待收货">
                </a-tab-pane>
                <a-tab-pane key="Z_FINISHED" tab="已完成">
                </a-tab-pane>
            </a-tabs>
            <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
                     :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}"
                     rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination"
                     @change="gridChangeAction">
                <span slot="operate" slot-scope="text, record">
                  <a class="custom-primary-act" @click="()=>detailAction(record.id, '3')">详情</a>
                  <a-divider type="vertical"/>
                  <a :class="record.status!='B_WAIT_ACCEPT' ? 'custom-normal-act' : 'custom-primary-act'"
                     :disabled="record.status!='B_WAIT_ACCEPT'" @click="()=>detailAction(record.id, '1')">受理</a>
                  <a-divider type="vertical"/>
                  <a :class="record.status!='C_ACCEPTED' ? 'custom-normal-act' : 'custom-primary-act'"
                     :disabled="record.status!='C_ACCEPTED'" @click="()=>detailAction(record.id, '2')">发药</a>
                  <a-divider type="vertical"/>
                  <a :class="( (record.take == 'DELIVERY'|| record.take == 'SENT_CLINIC') && record.model == 'EXPRESS_DELIVERY' && (record.status=='D_DELIVERED' || record.status == 'Z_FINISHED')) ? 'custom-primary-act' : 'custom-normal-act'"
                     :disabled="!((record.take == 'DELIVERY'|| record.take == 'SENT_CLINIC') && record.model == 'EXPRESS_DELIVERY' && (record.status=='D_DELIVERED' || record.status == 'Z_FINISHED'))"
                     @click="()=>logisticsAction(record)">物流</a>
                  <a-divider type="vertical" />
                  <a
                     :class="( record.status=='D_DELIVERED' && record.take == 'ABHOLUNG') ? 'custom-primary-act' : 'custom-normal-act'"
                     :disabled="!( record.status=='D_DELIVERED' && record.take == 'ABHOLUNG')"
                     @click="()=>showConformAction(record.id, record.take)">确认收药</a>
                  <a-divider type="vertical"/>
                  <a :class="record.status=='B_WAIT_ACCEPT' ? 'custom-normal-act' : 'custom-primary-act'"
                     :disabled="record.status=='B_WAIT_ACCEPT'" class="custom-primary-act"
                     @click="()=>printAction(record.id)">打印处方笺</a>

                </span>
            </a-table>
        </a-spin>
        <a-modal :title="modal.type == '1' ? '处方受理' : (modal.type == '2' ? '处方发药' : '处方详情' )" :visible="modal.visible"
                 width="70%" @cancel="closeModal"
                 :okText="modal.type == '1' ? '确认受理' : (modal.type == '2' ? '确认发药' : '确定' )" @ok="okAction()">
            <a-spin :spinning="modal.loading" :tip="modal.tip">
                <a-form :form="modal.form" layout="horizontal">
                    <a-row>
                        <a-col span="1"></a-col>
                        <a-col span="23">
                            <a-descriptions>
                                <a-descriptions-item label="患者姓名">
                                    {{modal.record.name}}
                                </a-descriptions-item>
                                <a-descriptions-item label="性别">
                                    {{modal.record.sexName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="年龄">
                                    {{modal.record.ageDesc}}
                                </a-descriptions-item>
                                <a-descriptions-item label="就诊医院">
                                    {{modal.record.hospitalName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="流转机构">
                                    {{modal.record.organName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="申请时间">
                                    {{modal.record.applyTime}}
                                </a-descriptions-item>
                                <a-descriptions-item label="处方类型">
                                    {{modal.record.typeName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="处方单号">
                                    {{modal.record.code}}
                                </a-descriptions-item>
                                <a-descriptions-item label="加工方式">
                                    {{modal.record.usageModelName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="取药方式">
                                    {{modal.record.takeName}}
                                </a-descriptions-item>
                                <a-descriptions-item label="收货人">
                                    {{modal.record.consigneeName}}<span
                                        v-if="modal.record.consigneePhone!=null && modal.record.consigneePhone!=''">({{modal.record.consigneePhone}})</span>
                                </a-descriptions-item>
                                <a-descriptions-item label="收货地址">
                                    {{modal.record.district}} {{modal.record.address}}
                                </a-descriptions-item>
                            </a-descriptions>
                        </a-col>
                    </a-row>
                    <a-row v-if="modal.type == '2' && modal.record.take != 'ABHOLUNG' ">
                        <a-col span="8" class="span-col height-45">
                            <a-form-item :colon="false" label="送货方式"
                                         :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                <a-select
                                        v-decorator="['model', {rules: [{ required: true, message: '送货方式必须选择!' }], initialValue : modal.params.model }]"
                                        :disabled="modal.record.take == 'DELIVERY'" @change="modalChange">
                                    <a-select-option v-for="item in modal.models" :key="item.name" :value="item.name">
                                        {{item.value}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col v-if="modal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
                            <a-form-item :colon="false" label="快递公司"
                                         :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-select v-decorator="['unit', {rules: [{ required: true, message: '快递公司必须选择!' }]}]">
                                    <a-select-option v-for="item in modal.units" :key="item.name" :value="item.name">
                                        {{item.value}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col v-else span="8" class="span-col height-45">
                            <a-form-item :colon="false" label="送货人" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-input
                                        v-decorator="['deliverer', {rules: [{ required: true, message: '送货人姓名必须填写!' }], initialValue:'' }]"
                                        placeholder="请输入送货人姓名"/>
                            </a-form-item>
                        </a-col>
                        <a-col v-if="modal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
                            <a-form-item :colon="false" label="快递单号"
                                         :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-input
                                        v-decorator="['expressNo', {rules: [{ required: true, message: '快递单号必须填写!' }] }]"
                                        placeholder="请输入快递单号"/>
                            </a-form-item>
                        </a-col>
                        <a-col v-else span="8" class="span-col height-45">
                            <a-form-item :colon="false" label="联系电话"
                                         :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-input
                                        v-decorator="['phone', {rules: [{ required: true, message: '送货人联系电话必须填写!' }], initialValue:'' }]"
                                        placeholder="请输入送货人联系电话"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="modal.type == '3' && null!=modal.record.delivery ">
                        <a-col span="1"></a-col>
                        <a-col span="23">
                            <a-descriptions>
                                <a-descriptions-item label="送货方式">
                                    {{null!=modal.record.delivery ? modal.record.delivery.modelName : ''}}
                                </a-descriptions-item>
                                <a-descriptions-item v-if="modal.record.delivery.model=='EXPRESS_DELIVERY'"
                                                     label="快递公司">
                                    {{modal.record.delivery.expressName}}
                                </a-descriptions-item>
                                <a-descriptions-item v-if="modal.record.delivery.model=='EXPRESS_DELIVERY'"
                                                     label="快递单号">
                                    {{modal.record.delivery.expressNo}}
                                </a-descriptions-item>
                                <a-descriptions-item label="送货人">
                                    {{modal.record.delivery.deliverer}}
                                </a-descriptions-item>
                                <a-descriptions-item label="联系电话">
                                    {{modal.record.delivery.delivererPhone}}
                                </a-descriptions-item>
                            </a-descriptions>
                        </a-col>
                    </a-row>
                </a-form>
                <a-tabs default-active-key="1" size="small" style="min-height: 260px;">
                    <a-tab-pane key="1" tab="流转处方">
                        <a-table size="middle" :columns="modal.grid.columns" rowKey="code"
                                 :dataSource="modal.grid.datas" :scroll="{ x: '100%' }">
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </a-spin>
        </a-modal>
        <a-modal :title="null" :centered="true" :mask-closable="false" :closable="false" :width="620"
                 :visible="printModal.visible"
                 :footer="null" :body-style="{'padding':'12px', 'borderRadius':'4px'}">
            <div style="max-height: 800px; overflow-y: auto;" align="center">
                <div id="printDiv" style="width: 570px;" align="left">
                    <a-row style="margin-bottom: 20px;">
                        <a-col span="24">
                            <a-row>
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       style="text-align: center;font-size: 20px; font-weight: bold;margin-bottom: 10px;">
                                    {{ printModal.record.hospitalName }}
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       style="text-align: center;font-size: 16px; font-weight: bold;margin-bottom: 10px;">
                                    门诊{{ printModal.record.type == 'CM' ? '中药处方' : printModal.record.type == 'CPM' ?
                                    '中成药处方' : printModal.record.type == 'WM' ? '西药处方' : '处方' }}笺
                                </a-col>
                            </a-row>
                            <a-row class="row-flex" style="margin-left: 8px;line-height:32px;margin-bottom: 5px;">
                                <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span>科别:</span><span
                                        class="b-border">{{ printModal.record.department || '-' }}</span></a-col>
                                <a-col :sm="24" :xs="5" :md="5" :lg="5" :xl="5" :xxl="5"><span>类别:</span><span
                                        class="b-border">自费</span>
                                </a-col>
                                <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span>门诊号:</span><span
                                        class="b-border">{{ printModal.record.code || '-' }}</span></a-col>
                                <a-col :sm="24" :xs="6" :md="6" :lg="6" :xl="6" :xxl="6"><span
                                        class="b-border">{{ printModal.record.applyTime || '-' }}</span></a-col>
                            </a-row>
                            <a-row style="line-height:32px;">
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       class="t-border b-border l-border r-border"
                                >
                                    <a-row class="row-flex" style="margin-left: 8px">
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span
                                                class="medical-label">姓名:</span><span
                                                class="b-border">{{ printModal.record.name || '-' }}</span></a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span
                                                class="medical-label">年龄:</span><span
                                                class="b-border">{{ printModal.record.ageDesc || '-' }}</span></a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8"><span
                                                class="medical-label">性别:</span><span
                                                class="b-border">{{ printModal.record.sexName || '-' }}</span></a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row style="line-height:32px;">
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       class="b-border l-border r-border"
                                >
                                    <a-row class="row-flex" style="margin-left: 8px">
                                        <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"><span
                                                class="medical-label">临床诊断:</span>{{ printModal.record.diagnostic || '-'
                                            }}
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       class="b-border l-border r-border"
                                       style="padding-left: 3px;height: 500px;">
                                    <a-row class="row-flex">
                                        <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                                            <a-row class="row-flex">
                                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                                       style="margin-left: 10px; padding-top: 3px; padding-bottom: 3px;font-weight: bold;">
                                                    Rp.
                                                </a-col>
                                            </a-row>
                                            <a-row v-if="printModal.record.type == 'CM'">
                                              <template v-if="(printModal.record.drugs||[]).length> 1">
                                                <template v-for="(e, i) in printModal.record.drugs">
                                                  <a-col key="drugId" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="12" :md="12" :lg="12" :xl="12" :xxl="12">
                                                    {{ e.drugName }}{{ e.spec }}&nbsp;&nbsp;{{ e.dosage }}{{ e.unit
                                                    }}<span v-if="(e.desc||'') != ''" style="margin-left: 5px;">,({{ e.desc }})</span>
                                                    <span v-if="(e.usage||'') != ''" style="margin-left: 5px;">,({{ e.usage }})</span>
                                                  </a-col>
                                                </template>
                                              </template>
                                              <template v-else>
                                                <template v-for="(e, i) in printModal.record.drugs">
                                                  <a-col key="drugId" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                                                    {{ e.drugName }}{{ e.spec }}&nbsp;&nbsp;{{ e.dosage }}{{ e.unit
                                                    }}<span v-if="(e.desc||'') != ''" style="margin-left: 5px;">,({{ e.desc }})</span>
                                                    <span v-if="(e.usage||'') != ''" style="margin-left: 5px;">,({{ e.usage }})</span>
                                                  </a-col>
                                                </template>
                                              </template>
                                            </a-row>
                                            <a-row v-else>
                                                <a-col v-for="(e, i) in printModal.record.drugs" key="drugId"
                                                       style="padding-left: 20px;white-space:nowrap;" :sm="24"
                                                       :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                                                    <div>{{ (i + 1) }}.&nbsp;{{ e.drugName }}&nbsp;&nbsp;{{ e.spec}}&nbsp;&nbsp;{{
                                                        e.salesQty }}{{ e.salesUnit }}
                                                    </div>
                                                    <div style="margin-left: 5px;">
                                                        用法:&nbsp;&nbsp;&nbsp;{{ e.usage }}&nbsp;&nbsp;&nbsp;{{ e.dosage
                                                        }}{{ e.unit }}&nbsp;&nbsp;&nbsp;{{ e.frequency }}
                                                    </div>
                                                </a-col>
                                            </a-row>
                                            <a-row>
                                                <a-col style="text-align: left; line-height: 24px;padding-left: 40px;margin-top: 12px;">
                                                    <span v-if="printModal.record.type == 'CM'">{{ printModal.record.doses }}付{{ (printModal.record.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                                                    {{ printModal.record.usage || '' }}
                                                </a-col>
                                            </a-row>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                                       class="b-border l-border r-border"
                                       style="padding-left: 2px;">
                                    <a-row class="row-flex" style="line-height:32px;margin-left: 8px">
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">医师:</span><span
                                                class="b-border">{{printModal.record.doctorName}}</span>
                                        </a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">审核:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">金额:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </a-col>
                                    </a-row>
                                    <a-row class="row-flex" style="line-height:32px;margin-left: 8px">
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">调配:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">核对:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </a-col>
                                        <a-col :sm="24" :xs="8" :md="8" :lg="8" :xl="8" :xxl="8">
                                            <span class="medical-label">发药:</span><span class="b-border">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div style="text-align: center;margin-top: 12px; height: 32px;">
                <a-button class="custom-primary-btn" size="default" style="margin-left: 10px" v-print="'#printDiv'">打印
                </a-button>
                <a-button class="custom-warn-btn" size="default" style="margin-left: 10px"
                          @click="()=>printModalClose()">关闭
                </a-button>
            </div>
        </a-modal>
        <a-modal :title="conformModal.title" :visible="conformModal.visible" width="70%" @cancel="conformModal.visible = false"
                 okText="确认收货" @ok="receiveSubmitAction()">
            <a-spin :spinning="conformModal.loading" :tip="conformModal.tip">
                <a-form :form="conformModal.form" layout="horizontal">
                    <a-row>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="患者姓名" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.name}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="性别" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.sexName}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="年龄" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.ageDesc}}
                            </a-form-item>
                        </a-col>

                    </a-row>
                    <a-row class="">
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="就诊医院" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.hospitalName}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="流转机构" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.organName}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="申请时间" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.applyTime}}
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="处方类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.typeName}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="处方单号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.code}}
                            </a-form-item>
                        </a-col>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="加工方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.usageModelName}}
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row class="searchrow">
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="取药方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{conformModal.record.takeName}}
                            </a-form-item>
                        </a-col>
                        <a-col span="16" class="span-col height-45">
                            <a-form-item label="收货人" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                {{conformModal.record.consigneeName}}<span
                                    v-if="conformModal.record.consigneePhone!=null && conformModal.record.consigneePhone!=''">({{conformModal.record.consigneePhone}})</span>
                                <span v-if="(conformModal.record.district!=null && conformModal.record.district!='')||(conformModal.record.address!=null && conformModal.record.address!='')">({{conformModal.record.district}} {{conformModal.record.address}})</span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="8" class="span-col height-45">
                            <a-form-item label="送货方式" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{null != conformModal.record.delivery ? conformModal.record.delivery.modelName : ''}}
                            </a-form-item>
                        </a-col>
                        <a-col v-if="modal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
                            <a-form-item label="快递公司" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{null != conformModal.record.delivery ? conformModal.record.delivery.expressName : ''}}
                            </a-form-item>
                        </a-col>
                        <a-col v-else span="8" class="span-col height-45">
                            <a-form-item label="送货人" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{null != conformModal.record.delivery ? conformModal.record.delivery.deliverer : ''}}
                            </a-form-item>
                        </a-col>
                        <a-col v-if="conformModal.params.model=='EXPRESS_DELIVERY'" span="8" class="span-col height-45">
                            <a-form-item label="快递单号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{null != conformModal.record.delivery ? conformModal.record.delivery.expressNo : ''}}
                            </a-form-item>
                        </a-col>
                        <a-col v-else span="8" class="span-col height-45">
                            <a-form-item label="联系电话" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                {{null != conformModal.record.delivery ? conformModal.record.delivery.delivererPhone :
                                ''}}
                            </a-form-item>
                        </a-col>
                        <a-col v-if="conformModal.record.take == 'ABHOLUNG' " span="8"
                               class="span-col height-45">
                            <a-form-item label="收货码" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-input v-decorator="['salt', {rules: [{ required: true, message: '收货码必须填写!' }] }]"
                                         placeholder="请输入收货码"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <a-tabs default-active-key="1" size="small" style="min-height: 260px;">
                    <a-tab-pane key="1" tab="流转处方">
                        <a-table size="middle" :columns="conformModal.grid.columns" rowKey="code"
                                 :dataSource="conformModal.grid.datas" :scroll="{ x: '100%' }">
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </a-spin>
        </a-modal>
        <a-modal title="物流信息" :visible="logisticsModal.visible" width="70%" :bodyStyle="{'height':'500px'}"
                 @cancel="logisticsModal.visible=false" @ok="logisticsModal.visible=false">
            <a-spin :spinning="logisticsModal.loading" tip="正在加载数据...">
                <div style="height: 480px;overflow: auto">
                    <a-row style="margin-bottom: 10px; font-size: 20px">
                        <span style="font-weight: bolder">{{logisticsModal.logistics.unitName||''}}</span> <span
                            style="margin-left: 8px">{{logisticsModal.logistics.expressNo}}</span>
                    </a-row>
                    <a-steps v-if="logisticsModal.logistics!=null && logisticsModal.logistics.items!=null"
                             direction="vertical" :current="0">
                        <a-step v-for="(item, index) in logisticsModal.logistics.items"
                                :title="item.time" :key="'l-'+(index+1)"
                                :description="item.context"/>
                    </a-steps>
                </div>
            </a-spin>
        </a-modal>

    </div>
</template>

<script>
    import Vue from 'vue';
    import Print from 'vue-print-nb'

    Vue.use(Print);  //注册
    export default {
        name: "RoamRecipe",
        data() {
            return {
                loading: false,
                init: {
                    organs: [],
                    statuses: statuses
                },
                search: {
                    hospitalId: '',
                    code: '',
                    status: ''
                },
                grid: {
                    loading: false,
                    columns: columns,
                    data: [],
                    selections: [],
                    pagination: this.$pagination
                },
                modal: {
                    loading: false,
                    visible: false,
                    type: '1', //1-受理  2-发货  3-详情
                    tip: "正在加载数据...",
                    record: {},
                    models: [],
                    btnProps: {
                        props: {disabled: true}
                    },
                    params: {model: 'EXPRESS_DELIVERY', deliverer: '', phone: '', expressNo: '', unit: ''},
                    grid: {
                        columns: drugColumns,
                        datas: []
                    },
                    form: this.$form.createForm(this),
                },
                logisticsModal: {
                    loading: false,
                    visible: false,
                    record: {},
                    logistics: {},
                },
                conformModal: {
                    loading: false,
                    visible: false,
                    title: '确认收药',
                    tip: "正在加载数据...",
                    record: {},
                    models: [],
                    btnProps: {
                        props: {disabled: true}
                    },
                    params: {model: 'EXPRESS_DELIVERY', deliverer: '', phone: '', expressNo: '', unit: ''},
                    grid: {
                        columns: drugColumns,
                        datas: []
                    },
                    form: this.$form.createForm(this),
                },
                printModal: {
                    visible: false,
                    record: {}
                }
            }
        },
        beforeCreate() {
            let data = [{
                text: "首页",
                path: ""
            }, {
                text: "云药房",
                path: ""
            }, {
                text: "处方流转(受理机构)",
                path: ""
            }];
            this.$store.commit('updateBreadcrumb', data);
        },
        mounted() {
            let self = this;
            this.loadHospitals();
            this.searchAction();
            this.getDeliveryModels(function (res) {
                self.modal.models = res || []
            });
            this.getExpressUnits(function (res) {
                self.modal.units = res || []
            });
            this.interval = setInterval(() => {
                self.searchAction()
            }, 120000);
        },
        methods: {

            loadHospitals: function () {
                let self = this;
                this.$axios.get('/api/clinic/roam/organs', {}).then(function (res) {
                    if (res.msg.flag == 0) {
                        self.init.organs = res.biz;
                    }
                })
            },

            buildParams: function () {
                return {
                    'entity.hospitalId': this.search.hospitalId,
                    'entity.code': this.search.code,
                    'entity.status': this.search.status,
                };
            },

            tabChange: function (e) {
                if (e == 'ALL') {
                    this.search.status = '';
                } else {
                    this.search.status = e;
                }
                this.searchAction();
            },

            /**
             * 搜索按钮点击动作
             */
            searchAction: function () {
                console.info('..查询')
                Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
                let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
                this.loadGrid(params);
            },

            /**
             * 分页条操作
             */
            gridChangeAction: function (pagination, filters, sorter) {
                Object.assign(this.grid, {pagination: pagination});
                let params = Object.assign(this.buildParams(), {
                    start: (pagination.current - 1) * pagination.pageSize,
                    length: pagination.pageSize
                });
                this.loadGrid(params);
            },

            logisticsAction: function (record) {
                let self = this;
                this.logisticsModal.logistics = {};
                this.logisticsModal.record = record;
                this.logisticsModal.visible = true;
                self.modal.loading = true;
                self.$axios.get('/api/clinic/roam/recipe/' + record.id + '/logistics', {}).then(function (res) {
                    self.modal.loading = false;
                    if (res.msg.flag == 0) {
                        if (null == res.biz) {
                            self.$message.info({content: res.msg.message, duration: 2});
                        } else {
                            Object.assign(self.logisticsModal.logistics, res.biz);
                        }
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.modal.loading = false;
                    self.$message.error({content: '加载数据失败', duration: 2});
                });
            },

            /**
             *  行选择事件
             */
            onSelectChange: function (selectedRowKeys) {
                this.grid.selections = selectedRowKeys;
            },

            /**
             * 查询流转处方
             */
            loadGrid: function (params) {
                const self = this;

                self.grid.loading = true;
                self.$axios.get('/api/clinic/roam/recipes', {params: params}).then(function (res) {
                    self.grid.loading = false;
                    if (res.msg.flag == 0) {
                        if (null == res.biz || res.biz.empty) {
                            self.$message.info({content: res.msg.message, duration: 2});
                            Object.assign(self.grid, {
                                data: [],
                                pagination: Object.assign(self.grid.pagination, {total: 0})
                            });
                        } else {
                            Object.assign(self.grid, {
                                data: res.biz.data,
                                pagination: Object.assign(self.grid.pagination, {total: res.biz.count})
                            });
                            if (res.biz.data.filter(e => e.status == 'B_WAIT_ACCEPT').length > 0) {
                                let voice = document.getElementById("voice");
                                voice.currentTime = 0;
                                voice.play();
                            }
                        }
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.grid.loading = false;
                });
            },

            detailAction: function (id, type) {
                let self = this;
                self.modal.record = {};
                self.modal.grid.datas = [];
                self.modal.type = type; //1-受理  2-发货 3-详情
                self.modal.tip = "正在加载数据...";
                self.modal.visible = true;

                self.modal.loading = true;
                self.$axios.get('/api/clinic/roam/recipe/' + id, {}).then(function (res) {
                    self.modal.loading = false;
                    if (res.msg.flag == 0) {
                        if (null == res.biz) {
                            self.$message.info({content: res.msg.message, duration: 2});

                        } else {
                            Object.assign(self.modal.record, res.biz);
                            if (res.biz != null && res.biz.take == 'DELIVERY') {
                                self.modal.params.model = 'EXPRESS_DELIVERY';
                            }

                            Object.assign(self.modal.grid.datas, res.biz.drugs)
                        }
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.modal.loading = false;
                    self.$message.error({content: '加载数据失败', duration: 2});
                });
            },

            showConformAction: function (id) {
                let self = this;
                self.conformModal.record = {};
                self.conformModal.grid.datas = [];
                self.conformModal.tip = "正在加载数据...";
                self.conformModal.visible = true;
                self.conformModal.loading = true;
                self.$axios.get('/api/clinic/roam/recipe/' + id, {}).then(function (res) {
                    self.conformModal.loading = false;
                    if (res.msg.flag == 0) {
                        if (null == res.biz) {
                            self.$message.info({content: res.msg.message, duration: 2});
                        } else {
                            Object.assign(self.conformModal.record, res.biz);
                            Object.assign(self.conformModal.grid.datas, res.biz.drugs)
                        }
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.conformModal.loading = false;
                    self.$message.error({content: '加载数据失败', duration: 2});
                });
            },

            printAction: function (id) {
                let self = this;
                self.printModal.record = {};

                self.printModal.loading = true;
                self.$axios.get('/api/clinic/roam/recipe/' + id, {}).then(function (res) {
                    self.printModal.loading = false;
                    if (res.msg.flag == 0) {
                        if (null == res.biz) {
                            self.$message.info({content: res.msg.message, duration: 2});
                        } else {
                            Object.assign(self.printModal.record, res.biz);
                            self.printModal.visible = true;
                        }
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.printModal.loading = false;
                    self.$message.error({content: '加载数据失败', duration: 2});
                });
            },

            okAction: function () {
                if (this.modal.type == '1') {
                    this.acceptSubmitAction();
                } else if (this.modal.type == '2') {
                    this.dispenseSubmitAction();
                } else {
                    this.modal.visible = false;
                }
            },

            receiveSubmitAction: function () {
                let self = this;

                self.conformModal.form.validateFields((errs, values) => {
                    if (!errs) {
                        let url = '';
                        if (self.conformModal.record.take == 'ABHOLUNG') {
                            url = 'api/clinic/roam/recipe/' + self.conformModal.record.id + '/collect/' + values.salt;
                        } else {
                            url = '/api/clinic/roam/recipe/' + self.conformModal.record.id + '/receive'
                        }
                        self.conformModal.tip = '正在确认收药信息...';
                        self.conformModal.loading = true;
                        self.$axios.post(url, {}).then(function (res) {
                            self.conformModal.loading = false;
                            if (res.msg.flag == 0) {
                                self.conformModal.visible = false;
                                self.$message.success({content: '收药确认成功', duration: 2});
                                self.gridChangeAction(self.grid.pagination)
                            } else {
                                self.$message.error({content: res.msg.message, duration: 2})
                            }
                        })
                    }
                })
            },

            acceptSubmitAction: function () {
                let self = this;
                let _id = self.modal.record.id;
                self.modal.tip = '正在提交受理信息...';
                self.modal.loading = true;
                self.$axios.post('/api/clinic/roam/recipe/' + _id + '/accept', {}).then(function (res) {
                    if (res.msg.flag == 0) {
                        self.$message.success({content: '处方受理成功', duration: 2});
                        self.modal.visible = false;
                        self.gridChangeAction(self.grid.pagination);
                        self.printAction(_id);
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2})
                    }
                })

            },

            dispenseSubmitAction: function () {
                let self = this;

                self.modal.form.validateFields((errs, values) => {
                    if (!errs) {
                        let params = {
                            id: self.modal.record.id,
                            model: values.model,
                            deliverer: values.deliverer,
                            phone: values.phone,
                            expressNo: values.expressNo,
                            unit: values.unit
                        }

                        self.modal.tip = '正在提交发药操作...';
                        self.modal.loading = true;
                        self.$axios.post('/api/clinic/roam/recipe/dispense', params).then(function (res) {
                            if (res.msg.flag == 0) {
                                self.$message.success({content: '处方发药成功', duration: 2});
                                self.modal.visible = false;
                                self.gridChangeAction(self.grid.pagination)
                            } else {
                                self.$message.error({content: res.msg.message, duration: 2})
                            }
                        })
                    }
                })
            },

            modalChange: function (e) {
                this.modal.params.model = e;
            },


            closeModal: function () {
                this.modal.visible = false;
            },

            printModalClose: function () {
                this.printModal.visible = false;
            },


            testAction: function () {
                const self = this;
                self.grid.loading = true;
                self.$axios.get('/api/clinic/roam/test', {}).then(function (res) {
                    self.grid.loading = false;
                    if (res.msg.flag == 0) {
                        self.$message.error({content: '生成数据成功', duration: 2});
                    } else {
                        self.$message.error({content: res.msg.message, duration: 2});
                    }
                }, function () {
                    self.grid.loading = false;
                });
            }

        },
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    }

    let statuses = [
        {name: 'A_UNDERTRIAL', value: '待复审'},
        {name: 'B_WAIT_ACCEPT', value: '待受理'},
        {name: 'C_ACCEPTED', value: '已受理'},
        {name: 'D_DELIVERED', value: '已发货'},
        {name: 'Z_FINISHED', value: '已完成'},
    ];

    let columns = [
        {
            title: '处方单号',
            dataIndex: 'code',
            key: 'code',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 180
        },
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 75
        },
        {
            title: '性别',
            dataIndex: 'sexName',
            key: 'sexName',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 75
        },
        {
            title: '年龄',
            dataIndex: 'ageDesc',
            key: 'ageDesc',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 75
        },
        {
            title: '就诊机构',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            align: 'left',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 120
        },
        {
            title: '中药付数',
            dataIndex: 'doses',
            key: 'doses',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 90
        },
        {
            title: '处方金额',
            dataIndex: 'roamAmount',
            key: 'roamAmount',
            align: 'center',
            customRender: (text, record, index) => {
                let amount = text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
                if (record.usageAmount != undefined && record.usageAmount != null && record.usageAmount > 0) {
                    amount = amount + '(' + record.usageAmount + ')';
                }
                return amount;
            },
            width: 100
        },
        {
            title: '申请时间',
            dataIndex: 'applyTime',
            key: 'applyTime',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 140
        },
        {
            title: '取药方式',
            dataIndex: 'takeName',
            key: 'takeName',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 100
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 120
        },
        {
            title: '操作',
            key: 'operate',
            align: 'center',
            fixed: 'right',
            width: 360,
            scopedSlots: {customRender: 'operate'}
        }

    ]


    let drugColumns = [
        {
            title: '药品',
            dataIndex: 'drugName',
            key: 'drugName',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 180
        },
        {
            title: '规格',
            dataIndex: 'spec',
            key: 'spec',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 90
        },
        {
            title: '剂型',
            dataIndex: 'formName',
            key: 'formName',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined ? '-' : text;
            },
            width: 90
        },
        {
            title: '生产厂家',
            dataIndex: 'manufacturer',
            key: 'manufacturer',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 90
        },
        {
            title: '销售单位',
            dataIndex: 'salesUnit',
            key: 'salesUnit',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 90
        },
        {
            title: '销售单价',
            dataIndex: 'roamPrice',
            key: 'roamPrice',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
            },
            width: 90
        },
        {
            title: '销售数量',
            dataIndex: 'salesQty',
            key: 'salesQty',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text;
            },
            width: 120
        },
        {
            title: '销售金额',
            dataIndex: 'amount',
            key: 'amount',
            align: 'center',
            customRender: (text, record, index) => {
                return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
            },
            width: 120
        }

    ]
</script>

<style scoped>

    .span-col {
        height: 45px;
    }

    .t-border {
        border-top: #333333 solid 1px;
        min-height: 28px;
    }

    .l-border {
        border-left: #333333 solid 1px;
        min-height: 28px;
        align-items: center;
    }

    .b-border {
        border-bottom: #333333 solid 1px;
        min-height: 28px;
    }

    .r-border {
        border-right: #333333 solid 1px;
        min-height: 28px;
    }

    .medical-label {
        min-height: 28px;
        text-align: center;
        font-weight: bold;
    }

    .row-flex {
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .custom-primary-btn {
        border-radius: 16px;
        min-width: 88px;
        color: white;
        background-image: linear-gradient(to right, #127dac, #319bcc);
    }

    .custom-warn-btn {
        border-radius: 16px;
        color: white;
        min-width: 88px;
        background-image: linear-gradient(to right, #f18a61, #f1985d);
    }

</style>
